import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  selector: {
    width: '100%',
  },
  input: {
    width: '100%',
  },
  timeSetterWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',

    '& > div': {
      width: '100%',
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
